const aboutUsRoutes = {
    name: 'aboutUsLayout',
    path: '/aboutUs',
    component: () => import('@/layout/index.vue'),
    redirect: '/aboutUsIndex',
    children: [
        {
            path: '/aboutUsIndex',
            component: () => import('@/views/aboutUs/index.vue'),
            meta: {
                title: '关于我们'
            }
        }
    ]
}

const aboutUsWhite = [
    {
		path: '/aboutUs'
	},
    {
		path: '/aboutUsIndex'
	}
]

export {
    aboutUsRoutes,
    aboutUsWhite
}